// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"b5608ae6b1224690","5763":"d8cbd52847f9f7e5","6893":"abdf0d92f512a7db","6974":"9fb6dc9429409134","7222":"793458efadc971ea","7937":"8f78ea2281669904"}[chunkId] + ".js";
};